import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageCroppedEvent } from 'ngx-image-cropper';

/**
 * Kimlik kartı okunamadığında personel kartın sınırlarını seçer (masak-kimlik-ocr.md §5.5).
 * Kırpılan görsel YALNIZCA OCR için kullanılır; yüklenen kimlik belgesi özgün görsel kalır.
 * Sonuç: kırpılmış PNG (File) ya da dismiss.
 */
@Component({
  selector: 'app-masak-identity-crop-modal',
  templateUrl: './masak-identity-crop-modal.component.html',
})
export class MasakIdentityCropModalComponent {
  @Input() file!: File;
  @Input() sideText = '';

  rotation = 0;
  cropped?: Blob | null;
  loadFailed = false;

  constructor(public activeModal: NgbActiveModal) {}

  onCropped(event: ImageCroppedEvent) {
    this.cropped = event.blob;
  }

  rotate() {
    this.rotation = (this.rotation + 1) % 4;
  }

  confirm() {
    if (!this.cropped) return;
    this.activeModal.close(new File([this.cropped], 'kimlik-kirpilmis.png', { type: 'image/png' }));
  }
}
